(function () {

    'use strict';
    angular.module('iplusjs.mapper.money', [
        'numbro',
        'lodash',
        'iplusjs.utils.money'
    ])
        .directive('iplusjsMoneyMapper', moneyMapper);

    moneyMapper.$inject = [
        'numbro',
        'lodash',
        'MoneyUtilsService'
    ];
    function moneyMapper(numbro, _, MoneyUtilsService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1000,
            link: function ($scope, $element, $attrs, $ngModel) {
                var currency = $attrs.immCurrency;

                function toModel(value) {
                    value = _.isNil(value) ? '' : value;

                    if (_.isNaN(value) || !numbro.validate(value)) {
                        return null;
                    }

                    return MoneyUtilsService.toMoneyObject(value, currency);
                }

                function toView(value) {
                    return MoneyUtilsService.getAmount(value);
                }

                $ngModel.$parsers.push(toModel);
                $ngModel.$formatters.push(toView);
            }
        };
    }
})();
